module.exports = __webpack_public_path__ + "ca.svg?960555ec61a2c450ad9a1aa9b3514a7b";